var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_start_fill",
    "data-name": "icon start fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 12,
    viewBox: "0 0 12.8 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_star_fill",
    "data-name": "icon star fill",
    d: "M9.018,2.877l1.444,2.868a.688.688,0,0,0,.519.37l3.228.46a.672.672,0,0,1,.382,1.152L12.255,9.958a.668.668,0,0,0-.2.6l.551,3.152a.687.687,0,0,1-1,.712L8.721,12.933a.7.7,0,0,0-.642,0L5.192,14.421a.687.687,0,0,1-1-.712l.551-3.152a.668.668,0,0,0-.2-.6L2.209,7.726a.672.672,0,0,1,.382-1.152l3.228-.46a.688.688,0,0,0,.519-.37L7.782,2.877A.7.7,0,0,1,9.018,2.877Z",
    transform: "translate(-2 -2.5)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.2dd8b5fa25e7aa519549ae11723225c9.svg";
export { ForwardRef as ReactComponent };